import { h, JSX, FunctionalComponent } from "preact";
import { Icon } from "@uw/icons/types";
const defaultStyle = {
  width: "24px",
  height: "24px",
  display: "flex",
};
const SvgIcon = (props: JSX.SVGAttributes<any>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12" {...props}>
    <path
      fill="currentColor"
      fill-rule="evenodd"
      d="M3.43 2.285c0-.299-.003-.582.001-.864A1.41 1.41 0 0 1 4.522.04c.874-.218 1.75.454 1.762 1.355.004.291 0 .583 0 .889h2.224c.357 0 .67.11.913.383.193.217.29.473.29.763.002.709.001 1.417.001 2.125v.157c.272 0 .531-.002.791 0 .255.003.5.042.73.165.533.286.843.879.751 1.45-.103.644-.555 1.13-1.179 1.216-.3.042-.61.018-.915.023h-.178v2.261c-.001.646-.453 1.138-1.1 1.16a35.38 35.38 0 0 1-1.766.002c-.343-.005-.556-.25-.563-.594-.004-.198.001-.402-.043-.593a1.408 1.408 0 0 0-1.405-1.09 1.429 1.429 0 0 0-1.362 1.15c-.037.171-.041.351-.045.527-.008.36-.222.598-.583.602-.602.007-1.204.009-1.806-.008-.519-.014-1.001-.472-1.022-.993C-.01 10.355 0 9.716.009 9.08c.003-.256.231-.475.487-.498.163-.014.327-.011.49-.022.616-.04 1.128-.495 1.268-1.123A1.396 1.396 0 0 0 1.58 5.93a1.794 1.794 0 0 0-.957-.218c-.237.007-.429-.08-.543-.292a.624.624 0 0 1-.075-.276 69.275 69.275 0 0 1-.001-1.727c.009-.66.503-1.128 1.187-1.131.69-.004 1.381-.001 2.072-.001h.167Z"
    />
  </svg>
);
export const CognitiveLearningIcon: FunctionalComponent<Icon> = ({
  className,
  svgAttrs = {
    width: "100%",
    height: "100%",
  },
  key,
  jsx,
  children,
  ref,
  ...styles
}) => (
  <span
    className={className}
    style={{
      ...defaultStyle,
      ...styles,
    }}
  >
    <SvgIcon {...svgAttrs} />
  </span>
);
